export const Roles = {
  Admin: 'Admin',
  AccountMaster: 'Account Master',
  AccountUser: 'Account User'
};